import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Trending = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0625 4.4375C10.7864 4.4375 10.5625 4.66136 10.5625 4.9375C10.5625 5.21364 10.7864 5.4375 11.0625 5.4375H13.3554L8.4375 10.3554L5.29105 7.20895C5.09579 7.01368 4.77921 7.01368 4.58395 7.20895L1.08395 10.7089C0.888684 10.9042 0.888684 11.2208 1.08395 11.4161C1.27921 11.6113 1.59579 11.6113 1.79105 11.4161L4.9375 8.26961L8.08395 11.4161C8.27921 11.6113 8.59579 11.6113 8.79105 11.4161L14.0625 6.14461V8.4375C14.0625 8.71364 14.2864 8.9375 14.5625 8.9375C14.8386 8.9375 15.0625 8.71364 15.0625 8.4375V4.9375C15.0625 4.66136 14.8386 4.4375 14.5625 4.4375H11.0625Z"
        fill={color}
      />
    </svg>
  )
})

export default Trending
